import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { authApi, PublicUser } from '@/lib/auth';

export function useCurrentUser() {
  return useQuery<PublicUser | null>({
    queryKey: ['auth', 'me'],
    queryFn: () => authApi.me(),
    staleTime: 5 * 60_000,
    retry: false,
  });
}

export function useLogout() {
  const qc = useQueryClient();
  const navigate = useNavigate();
  return async () => {
    await authApi.logout();
    qc.setQueryData(['auth', 'me'], null);
    navigate('/');
  };
}
